var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ul',{attrs:{"id":"recipes"}},_vm._l((_vm.recipes),function(recipe){return _c('Recipe',{key:recipe.id,attrs:{"recipes":_vm.recipes,"recipe":recipe}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7c8b35e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recipes.vue
// module id = Vt04
// module chunks = 1